<template>
  <component
    :key="item.key"
    v-bind="item.props || {}"
    :is="getComponent(item.component)"
    :value="get(item.key)"
    :data-field="item.key"
    :disabled="Boolean(item.disabled || getDisabledField(item.key))"
    @input="$ev => set(item.key, $ev)"
    :validator="validator"
    v-tooltip.bottom="item.disabled || getDisabledField(item.key)"
  >
    <template v-for="(slotItems, slot) in item.slots" v-slot:[slot]="slotScope">
      <component
        v-for="(slotItem, index) of slotItems"
        :key="item.key + slot + index"
        v-bind="{ ...slotItem.props, ...slotScope }"
        :is="getComponent(slotItem.component)"
        :value="$path('props.value', slotItem) || get(item.key)"
        :disabled="Boolean(getDisabledField(item.key))"
        @input="$ev => set(item.key, $ev)"
      />
    </template>
  </component>
</template>

<script>
import { mapGetters } from 'vuex'
import { setByPath } from '@/utils'
import { MediaComponent } from '@kvass/media'
import MediaRecommendation from '@/components/MediaRecommendation'
import RichTextComponent from '@kvass/rich-text'
import MediaOnDrop from '@/components/vendors/kvass-media/onDrop'
import FileOnDrop from '@/components/vendors/kvass-file/onDrop'
import { FileComponent } from '@kvass/file'
import { InputComponent } from 'vue-elder-input'
import { DropdownComponent } from 'vue-elder-dropdown'
import ColorSelector from '@kvass/custom-fields/src/Fields/ColorSelector'
import PageSettings from './PageSettings.vue'
import Publishing from './Publishing.vue'
import ThemeSelector from './ThemeSelector.vue'
import Flatfinder from '@/components/Project/Flatfinder.vue'

export default {
  computed: {
    ...mapGetters('Project', ['getDisabledField']),
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    placement: {
      type: String,
    },
  },
  methods: {
    get(key) {
      return this.$path(key, this.value)
    },
    set(key, value) {
      setByPath(key, value, this.value)
    },

    getComponent(item) {
      const items = {
        MediaComponent: MediaComponent,
        FileComponent: FileComponent,
        DropdownComponent: DropdownComponent,
        InputComponent: InputComponent,
        MediaRecommendation: MediaRecommendation,
        RichTextComponent: RichTextComponent,
        FileOnDrop: FileOnDrop,
        ColorSelector: ColorSelector,
        PageSettings: PageSettings,
        Publishing,
        ThemeSelector: ThemeSelector,

        Flatfinder: Flatfinder,
        MediaOnDrop: MediaOnDrop,
      }

      return items[item] || item
    },
  },
}
</script>

<style lang="scss"></style>
